var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 0.625,
    width: 78.75,
    height: 78.75,
    rx: 19.375,
    fill: "#6C6F74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5026 56.6663H45.5026C53.8359 56.6663 57.1693 53.333 57.1693 44.9997V34.9997C57.1693 26.6663 53.8359 23.333 45.5026 23.333H35.5026C27.1693 23.333 23.8359 26.6663 23.8359 34.9997V44.9997C23.8359 53.333 27.1693 56.6663 35.5026 56.6663Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4974 36.6667C37.3383 36.6667 38.8307 35.1743 38.8307 33.3333C38.8307 31.4924 37.3383 30 35.4974 30C33.6564 30 32.1641 31.4924 32.1641 33.3333C32.1641 35.1743 33.6564 36.6667 35.4974 36.6667Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9492 51.5836L33.1659 46.0669C34.4826 45.1836 36.3826 45.2836 37.5659 46.3003L38.1159 46.7836C39.4159 47.9003 41.5159 47.9003 42.8159 46.7836L49.7492 40.8336C51.0492 39.7169 53.1492 39.7169 54.4492 40.8336L57.1659 43.1669",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 0.625,
    width: 78.75,
    height: 78.75,
    rx: 19.375,
    stroke: "#D2D2E1",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDefaultImage);
export default __webpack_public_path__ + "static/media/profileDefaultImage.499fe3345bf956b6fc1190f2f0abe9d0.svg";
export { ForwardRef as ReactComponent };